<style lang="postcss">
  .boxShadow {
    transition: all 0.5s linear;
  }

  .loader {
    animation: loader var(--duration) linear forwards;
    animation-iteration-count: 1;
  }

  .boxShadow::after {
    content: "";
    border-radius: 5px;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 80%;
    margin-bottom: -1rem;
    animation: changingOpacity 5s linear forwards infinite;
    --leftShadow: 5px;
    --rightShadow: -5px;
    --topShadow: 15px;
    --bottomShadow: 0px;
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  :global(.boxShadow.success::after), :global(.boxShadow.pending::after) {
    box-shadow: var(--leftShadow) var(--bottomShadow) var(--topShadow) #6fec75, 0px var(--bottomShadow) var(--topShadow) #009BFF, var(--rightShadow) var(--bottomShadow) var(--topShadow) #c1f6b1;
  }

  :global(.boxShadow.error::after) {
    box-shadow: var(--leftShadow) var(--bottomShadow) var(--topShadow) #b506c2, 0px var(--bottomShadow) var(--topShadow) #eb48c2, var(--rightShadow) var(--bottomShadow) var(--topShadow) #d122b4;
  }

  :globa(.notificationBox.pending) {
    @apply bg-primary bg-opacity-20;
  }

  :global(.notificationBox.success) {
    @apply bg-green-400 bg-opacity-40;
  }


  :global(.notificationBox.error) {
    @apply bg-pink-500 bg-opacity-40;
  }

  @keyframes changingOpacity {
    0% {
      opacity: 0.6;
    }
    10% {
      opacity: 1;
    }
    20% {
      opacity: 0.4;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 0.6;
    }
  }

  @keyframes loader {
    0% {
      width: 100%;
    }
    100% {
      width: 0%;
    }
  }

  :global(.notification-gradient.success), :global(.notification-gradient.pending) {
    @apply from-blue-200 to-green-500;
  }

  :global(.notification-gradient.error) {
    @apply from-blue-200 to-pink-500;
  }

  .notification-gradient-parent {
    @apply bg-opacity-30 bg-black;
  }
</style>

{#if $notification['visibility']}
  <div class="fixed boxShadow {$notification['type']} max-w-[355px] w-full z-3 flex flex-col" style='right: 0%; margin-right: {notificationMarginRight}; top: {notificationTop}' transition:fade>
    <div class="mb-4">
      <div class="w-full notificationBox {$notification['type']} relative rounded overflow-hidden">
          <div class="flex flex-row p-4">
            <div class="w-full flex p-0" style="z-index: 1000;">
                <div class="pr-4 text-white">
                  {#if $notification['type'] == 'success' }
                    <ExternalLink />
                  {:else if $notification['type'] == 'pending'}
                    <Spinner />
                  {:else}
                    <Error />
                  {/if}
                </div>
                <div class="flex flex-col gap-1">
                  <div class="font-bold text-high-emphesis text-white">{$notification['message']}</div>
                  {#if $notification['txid'] }
                    <a target="_blank" rel="noopener noreferrer" href="https://neonscan.org/tx/{$notification['txid']}" class="text-baseline whitespace-nowrap text-primary hover:text-high-emphesis focus:text-high-emphesis text-blue hover:underline p-0 md:p-0">
                      <div class="flex flex-row items-center gap-1">
                        View on explorer
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" width="20" height="20">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                        </svg>
                      </div>
                    </a>
                  {/if}
                </div>
            </div>
            <div class="hover:text-white cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" width="24" height="24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </div>
          </div>
          <div class="h-[3px] bg-dark-800 notification-gradient-parent w-full">
            <div id='loader' class="h-[3px] notification-gradient {$notification['type']} bg-gradient-to-r loader" on:animationend={hideNotification} style="width: 100%; --duration: {$notification['duration']}ms"></div>
          </div>
      </div>
    </div>
  </div>
{/if}

<script>
  $: notificationMarginRight = '150px'
  $: notificationTop = '150px'
  import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
  import ExternalLink from './../svgs/external-link.svelte';
  import Error from './../svgs/error.svelte';
  import Spinner from './../svgs/spinner.svelte';
  import { notification } from './../stores.js';

  let sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  let previousNotificationMessage = $notification['message'];

  $: ($notification['message'] != previousNotificationMessage) && refreshNotification();
  $notification['visibility'] = false;

  onMount(async () => {
    await sleep(200);

    setPosition();

    window.addEventListener('resize', function(event) {
      setPosition()
    }, true);
  });

  async function refreshNotification() {
    previousNotificationMessage = $notification['message']
    if(document.getElementById('loader')) {
      $notification['visibility'] = false;
      await sleep(500);
      $notification['visibility'] = true;
    }
  }

  function hideNotification() {
    // Update Store
    notification.update((currentNotification) => {
      currentNotification['visibility']   = false;
      currentNotification['txid'] = null;

      return currentNotification;
    });
  }

  function setPosition() {
    if(document.getElementById('navBar')) {
      notificationMarginRight = window.getComputedStyle(document.getElementById("navBar"))['margin-right'];
      notificationTop         = window.getComputedStyle(document.getElementById("navBar"))['height'];
    }
  }
</script>
